export {default as SD} from './SD';
export {default as NMR} from './NMR';
export {default as NMR2D} from './NMR2D';
export {Ranges, GUI, getACS} from 'spectra-data-ranges';



// WEBPACK FOOTER //
// ./node_modules/spectra-data/src/index.js